export default __webpack_public_path__ + "static/media/cart-01.ed342224.jpg";